import { Button, Text, Box, Input } from "@chakra-ui/react"
import WithAuth from "../components/hoc/with-auth"
import { AuthLayout } from "../components/layouts"
import { LayoutWithSidebar } from "../components/layouts/layout-with-sidebar.tsx"
import DealsPage from "../components/pages/deals-page/index"
import PositionPage from "../components/pages/positions-page"

const Positions = () => {
  return (
    <>
      <WithAuth>
        <LayoutWithSidebar pageTitle="Positions" pageDesc="List of all the positions">
          <PositionPage />
        </LayoutWithSidebar>
      </WithAuth>
    </>
  )
}

export default Positions
